// https://gist.github.com/jaredreich/9f4aa2a1d460100aa40ddbc279d85660

// https://github.com/sanohin/google-timezones-json/blob/master/timezones.json

export const TIME_ZONES = [
  {
    value: -12,
    text: "(GMT +12:00) Eniwetok, Kwajalein",
    chinese: "（GMT+12:00）埃尼威托克，夸贾林"
  },
  {
    value: -11,
    text: "(GMT -11:00) Midway Island, Samoa",
    chinese: "（GMT-11:00）中途岛，萨摩亚"
  },
  {
    value: -10,
    text: "(GMT -10:00) Hawaii",
    chinese: "（GMT-10:00）夏威夷"
  },
  {
    value: -9,
    text: "(GMT -9:00) Alaska",
    chinese: "（GMT-9:00）阿拉斯加"
  },
  {
    value: -8,
    text: "(GMT -8:00) Pacific Time (US & Canada)",
    chinese: "（GMT-8:00）太平洋时间（美国和加拿大）"
  },
  {
    value: -7,
    text: "(GMT -7:00) Mountain Time (US & Canada)",
    chinese: "（GMT-7:00）山地时间（美国和加拿大）"
  },
  {
    value: -6,
    text: "(GMT -6:00) Central Time (US & Canada), Mexico City",
    chinese: "（GMT-6:00）美国中部时间（美国和加拿大），墨西哥城"
  },
  {
    value: -5,
    text: "(GMT -5:00) Eastern Time (US & Canada), Bogota, Lima",
    chinese: "（GMT-5:00）东部时间（美国和加拿大），波哥大，利马"
  },
  {
    value: -4,
    text: "(GMT -4:00) Atlantic Time (Canada), Caracas, La Paz",
    chinese: "（GMT-4:00）大西洋时间（加拿大），加拉加斯，拉巴斯"
  },
  {
    value: -3.5,
    text: "(GMT -3:30) Newfoundland",
    chinese: "（GMT-3:30）纽芬兰"
  },
  {
    value: -3,
    text: "(GMT -3:00) Brazil, Buenos Aires, Georgetown",
    chinese: "（GMT-3:00）巴西，布宜诺斯艾利斯，乔治敦"
  },
  {
    value: -2,
    text: "(GMT -2:00) Mid-Atlantic",
    chinese: "（GMT-2:00）大西洋中部"
  },
  {
    value: -1,
    text: "(GMT -1:00) Azores, Cape Verde Islands",
    chinese: "（GMT-1:00）亚速尔群岛，佛得角群岛"
  },
  {
    value: 0,
    text: "(GMT) Western Europe Time, London, Lisbon, Casablanca",
    chinese: "（GMT）西欧时间，伦敦，里斯本，卡萨布兰卡"
  },
  {
    value: 1,
    text: "(GMT +1:00) Brussels, Copenhagen, Madrid, Paris",
    chinese: "（GMT+1:00）布鲁塞尔、哥本哈根、马德里、巴黎"
  },
  {
    value: 2,
    text: "(GMT +2:00) Kaliningrad, South Africa",
    chinese: "（GMT+2:00）加里宁格勒，南非"
  },
  {
    value: 3,
    text: "(GMT +3:00) Baghdad, Riyadh, Moscow, St. Petersburg",
    chinese: "（GMT+3:00）巴格达、利雅得、莫斯科、圣彼得堡"
  },
  {
    value: 3.5,
    text: "(GMT +3:30) Tehran",
    chinese: "（GMT+3:30）德黑兰"
  },
  {
    value: 4,
    text: "(GMT +4:00) Abu Dhabi, Muscat, Baku, Tbilisi",
    chinese: "（GMT+4:00）阿布扎比、马斯喀特、巴库、第比利斯"
  },
  {
    value: 4.5,
    text: "(GMT +4:30) Kabul",
    chinese: "（GMT+4:30）喀布尔"
  },
  {
    value: 5,
    text: "(GMT +5:00) Ekaterinburg, Islamabad, Karachi, Tashkent",
    chinese: "（GMT+5:00）叶卡捷琳堡、伊斯兰堡、卡拉奇、塔什干"
  },
  {
    value: 5.5,
    text: "(GMT +5:30) Bombay, Calcutta, Madras, New Delhi",
    chinese: "（GMT+5:30）孟买、加尔各答、马德拉斯、新德里"
  },
  {
    value: 5.75,
    text: "(GMT +5:45) Kathmandu",
    chinese: "（GMT+5:45）加德满都"
  },
  {
    value: 6,
    text: "(GMT +6:00) Almaty, Dhaka, Colombo",
    chinese: "（GMT+6:00）阿拉木图，达卡，科伦坡"
  },
  {
    value: 7,
    text: "(GMT +7:00) Bangkok, Hanoi, Jakarta",
    chinese: "（GMT+7:00）曼谷、河内、雅加达"
  },
  {
    value: 8,
    text: "(GMT +8:00) Beijing, Perth, Singapore, Hong Kong",
    chinese: "（GMT+8:00）北京，珀斯，新加坡，香港"
  },
  {
    value: 9,
    text: "(GMT +9:00) Tokyo, Seoul, Osaka, Sapporo, Yakutsk",
    chinese: "（GMT+9:00）东京、首尔、大阪、札幌、雅库茨克"
  },
  {
    value: 9.5,
    text: "(GMT +9:30) Adelaide, Darwin",
    chinese: "（GMT+9:30）阿德莱德，达尔文"
  },
  {
    value: 10,
    text: "(GMT +10:00) Eastern Australia, Guam, Vladivostok",
    chinese: "（GMT+10:00）澳大利亚东部、关岛、符拉迪沃斯托克"
  },
  {
    value: 11,
    text: "(GMT +11:00) Magadan, Solomon Islands, New Caledonia",
    chinese: "（GMT+11:00）马加丹，所罗门群岛，新喀里多尼亚"
  },
  {
    value: 12,
    text: "(GMT +12:00) Auckland, Wellington, Fiji, Kamchatka",
    chinese: "（GMT+12:00）奥克兰、惠灵顿、斐济、堪察加"
  }
];
